import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query UserListGridQuery(
    $startRow: Int
    $endRow: Int
    $sortModel: [Sort]
    $filters: [Filter]
    $companyId: ID!
  ) {
    Me {
      Company(id: $companyId) {
        Users(
          options: {
            startRow: $startRow
            endRow: $endRow
            sorting: $sortModel
            filters: $filters
          }
        ) {
          id
          tableId
          firstname
          lastname
          salutation
          title
          username
          permissions
          created
          last_activity
          email
        }
      }
    }
  }
`
